import * as React from "react";
import { Helmet } from "react-helmet";

export function AddResponsivenessTag() {
	return (
		<Helmet>
			<meta name="viewport" content="width=device-width, initial-scale=1.0" />
		</Helmet>
	);
}
